<template>
  <vg-view-field
      v-bind="$attrs"
      v-on="$listeners"
      class="vertical"
      :label="label"
  >
    <vg-image-uploader
        disabled
        :file-list="imageFiles"
        :preview-full-image="false"
        @click-preview="onPreview"
    />
  </vg-view-field>
</template>

<script>
import VgViewField from "@/components/Commons/VgViewField.vue";
import VgImageUploader from "@/components/Commons/VgImageUploader.vue";
import {client} from "@/libraries/http";
import {ImagePreview} from "vant";

export default {
  name: "ImagesField",
  components: {
    VgImageUploader,
    VgViewField
  },
  props: {
    label: String,
    value: Array
  },
  computed: {
    imageFiles() {
      return this.value?.map(url => ({url})) || []
    }
  },
  methods: {
    onPreview(file, detail) {
      let params = {
        urls: this.imageFiles.map(file => file.url)
      }
      client.post('/api/h5/file_app/getSignedUrls', params)
          .then(rsp => {
            ImagePreview({
              images: rsp.data,
              startPosition: detail.index,
            });
          })
    },
  }
}
</script>

<style scoped>

</style>